import { DateTime } from "luxon";
import { isString, isNumber, isNil } from "lodash";
import {
  parseToKyiv,
  getAgeFromDate as getAgeFromDateUtil,
  KYIV_TIMEZONE,
  DISPLAY_DATE_FORMAT
} from "./dateTime";

export type TDateType = string | number | Date | DateTime;

export const normalizedDateFormat = "yyyy-MM-dd'T'HH:mm:ssZZ";

export const isValidValue = (
  value: unknown,
): value is TDateType | null | undefined => {
  return (
    isString(value) ||
    isNumber(value) ||
    value instanceof DateTime ||
    value instanceof Date ||
    isNil(value)
  );
};

export const parseDatePickerValue = (
  value: unknown
): DateTime | null => {
  if (!isValidValue(value) || isNil(value)) return null;
  
  // If already a DateTime, make sure it's in the right timezone
  if (value instanceof DateTime) {
    return value.setZone(KYIV_TIMEZONE);
  }
  return parseToKyiv(value.toString());
};

export const formatDateTimeLight = (
  currentDate: TDateType | null,
  format = DISPLAY_DATE_FORMAT,
  currentFormat?: string,
): string | null => {
  if (!currentDate) return null;
  
  const parsed = currentFormat 
    ? parseToKyiv(currentDate, currentFormat)
    : parseToKyiv(currentDate);
    
  return parsed ? parsed.toFormat(format) : null;
};

export const getAgeFromDate = (dateString: string): number | null => {
  return getAgeFromDateUtil(dateString);
};
